import RootState from 'typings/RootState';

export const selectedProjectCodeSelector = (state: RootState) =>
  state.selectedProject.projectCode;
